import { RecipeCustomerDiaryActionType } from '../../api/models/recipe-customer-diary.models';
import { RecipeDiaryActionType } from '../../api/models/recipe-diary.models';
import {
  RecipeCustomerIngredientDiaryActionType,
  RecipeIngredientDiaryActionType,
} from '../../api/models/recipe-ingredient-diary.models';
import { RecipeMenuDiaryActionType } from '../../api/models/recipe-menu-diary.models';

export const getRecipeDiaryActionLabel = (actionType: number): string => {
  switch (actionType) {
    case RecipeDiaryActionType.RecipeHeader_Add:
      return 'Create recipe';
    case RecipeDiaryActionType.RecipeHeader_Update:
      return 'Update recipe';
    case RecipeDiaryActionType.RecipeHeader_Remove:
      return 'Delete recipe';
    case RecipeDiaryActionType.RecipeDetail_Add:
      return 'Add recipe detail';
    case RecipeDiaryActionType.RecipeDetail_Update:
      return 'Update recipe detail';
    case RecipeDiaryActionType.RecipeDetail_Remove:
      return 'Remove recipe detail';
    case RecipeDiaryActionType.RecipeHeaderPrivateUser_Add:
      return 'Add secret user';
    case RecipeDiaryActionType.RecipeHeaderPrivateUser_Remove:
      return 'Remove secret user';
    case RecipeDiaryActionType.RecipeHeader_Recover:
      return 'Recover recipe';
    case RecipeDiaryActionType.RecipeDetail_Sequence:
      return 'Sequence recipe detail';
    default:
      return '';
  }
};

export const getRecipeCustomerDiaryActionLabel = (actionType: number): string => {
  switch (actionType) {
    case RecipeCustomerDiaryActionType.RecipeCategory_Add:
      return 'Create recipe category';
    case RecipeCustomerDiaryActionType.RecipeCategory_Update:
      return 'Update recipe category';
    case RecipeCustomerDiaryActionType.RecipeCategory_Remove:
      return 'Remove recipe category';
    case RecipeCustomerDiaryActionType.RecipeCustomerUserManage_Add:
      return 'Add share user';
    case RecipeCustomerDiaryActionType.RecipeCustomerUserManage_Remove:
      return 'Remove share user';
    case RecipeCustomerDiaryActionType.RecipeCustomerShare_Add:
      return 'Share recipe';
    case RecipeCustomerDiaryActionType.RecipeCustomerShare_Remove:
      return 'Unshare recipe';
    case RecipeCustomerDiaryActionType.RecipeHeader_Remove:
      return 'Delete recipe';
    case RecipeCustomerDiaryActionType.RecipeCategory_Recover:
      return 'Recover recipe category';
    default:
      return '';
  }
};

export const getIngredientDiaryActionLabel = (actionType: number): string => {
  switch (actionType) {
    case RecipeIngredientDiaryActionType.RecipeIngredientHeader_Add:
      return 'Create ingredient';
    case RecipeIngredientDiaryActionType.RecipeIngredientHeader_Update:
      return 'Update ingredient';
    case RecipeIngredientDiaryActionType.RecipeIngredientHeader_Remove:
      return 'Delete ingredient';
    case RecipeIngredientDiaryActionType.RecipeIngredientProduct_Add:
      return 'Add ingredient product';
    case RecipeIngredientDiaryActionType.RecipeIngredientProduct_Update:
      return 'Update ingredient product';
    case RecipeIngredientDiaryActionType.RecipeIngredientProduct_Remove:
      return 'Remove ingredient product';
    case RecipeIngredientDiaryActionType.RecipeIngredientCustomerProductPrimary_Set:
      return 'Set primary ingredient product';
    case RecipeIngredientDiaryActionType.RecipeIngredientHeader_Recover:
      return 'Recover ingredient';
    case RecipeIngredientDiaryActionType.RecipeIngredientProduct_Sequence:
      return 'Sequence ingredient product';
    default:
      return '';
  }
};

export const getIngredientCustomerDiaryActionLabel = (actionType: number): string => {
  switch (actionType) {
    case RecipeCustomerIngredientDiaryActionType.RecipeIngredientCategory_Add:
      return 'Create ingredient category';
    case RecipeCustomerIngredientDiaryActionType.RecipeIngredientCategory_Update:
      return 'Update ingredient category';
    case RecipeCustomerIngredientDiaryActionType.RecipeIngredientCategory_Delete:
      return 'Remove ingredient category';
    case RecipeCustomerIngredientDiaryActionType.RecipeIngredientHeader_Remove:
      return 'Delete ingredient';
    case RecipeCustomerIngredientDiaryActionType.RecipeIngredientCategory_Recover:
      return 'Recover ingredient category';
    default:
      return '';
  }
};

export const getRecipeMenuDiaryActionLabel = (actionType: number): string => {
  switch (actionType) {
    case RecipeMenuDiaryActionType.RecipeMenuHeader_Add:
      return 'Create menu';
    case RecipeMenuDiaryActionType.RecipeMenuHeader_Update:
      return 'Update menu';
    case RecipeMenuDiaryActionType.RecipeMenuHeader_Remove:
      return 'Delete menu';
    case RecipeMenuDiaryActionType.RecipeMenuDetail_Add:
      return 'Add menu detail';
    case RecipeMenuDiaryActionType.RecipeMenuDetail_Update:
      return 'Update menu detail';
    case RecipeMenuDiaryActionType.RecipeMenuDetail_Remove:
      return 'Remove menu detail';
    case RecipeMenuDiaryActionType.RecipeMenuHeaderPrivateUser_Add:
      return 'Add secret user';
    case RecipeMenuDiaryActionType.RecipeMenuHeaderPrivateUser_Remove:
      return 'Remove secret user';
    case RecipeMenuDiaryActionType.RecipeMenuHeader_Recover:
      return 'Recover menu';
    default:
      return '';
  }
};
